export type PermissionModule = "projects" | "cronogramas" | "users";
export type PermissionAction = "view" | "edit" | "delete";

export interface ModulePermissions {
	view: boolean;
	edit: boolean;
	delete: boolean;
}

export interface UserPermissions {
	projects: ModulePermissions;
	cronogramas: ModulePermissions;
	users: ModulePermissions;
}

export interface AppUserProfile {
	uid: string;
	email: string;
	displayName: string;
	isActive: boolean;
	isSuperAdmin: boolean;
	permissions: UserPermissions;
	createdAt: string;
	updatedAt: string;
	createdBy?: string;
}

export interface SabasebaSessionUser {
	id: string;
	uid: string;
	email: string;
	username: string;
	firstName: string;
	lastName: string;
	role: string;
	token: string;
	isSuperAdmin: boolean;
	isActive: boolean;
	permissions: UserPermissions;
}

export const EMPTY_PERMISSIONS: UserPermissions = {
	projects: { view: false, edit: false, delete: false },
	cronogramas: { view: false, edit: false, delete: false },
	users: { view: false, edit: false, delete: false },
};

export const SUPER_ADMIN_PERMISSIONS: UserPermissions = {
	projects: { view: true, edit: true, delete: true },
	cronogramas: { view: true, edit: true, delete: true },
	users: { view: true, edit: true, delete: true },
};

export const hasPermission = (
	user: SabasebaSessionUser | null | undefined,
	module: PermissionModule,
	action: PermissionAction
): boolean => {
	if (!user || user.isActive === false) {
		return false;
	}
	if (user.isSuperAdmin) {
		return true;
	}
	return Boolean(user.permissions?.[module]?.[action]);
};
